import get from 'lodash/get';

export const isReadOnlyValue = (formValues, keyPath) =>
  get(formValues, keyPath, null) !== null ? true : false;
